import { useQuery } from '@tanstack/react-query';
import { searchBooks } from '../api/books';
import type { SearchBooksParams, SearchBooksResponse } from '../api/books';

interface UseSearchBooksOptions {
  onSuccess?: (data: SearchBooksResponse) => void;
  onError?: (error: Error) => void;
  enabled?: boolean;
}

export const useSearchBooks = (
  params: SearchBooksParams,
  options: UseSearchBooksOptions = {}
) => {
  return useQuery<SearchBooksResponse, Error>({ 
    queryKey: ['books', params], // Query key includes params for re-fetching
    queryFn: () => searchBooks(params),
    ...options,
  });
};
